import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { BLOGS_API } from '../api/blog-api';
import { BlogPostId, BlogPostsInterface } from '../types/blog-posts-interface';
export const useBlogPostApi = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== postFetcher) {
    t1 = {
      changePostStatus: (id, update) => postFetcher(`${BLOGS_API}/posts/${id}/${update}`)
    };
    $[1] = postFetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};